import { css } from "styled-components";

// @media max width
const maxWidths = {
  largeScreen: 1919,
  mediumScreen: 1536,
  desktop: 1440,
  mediumDesktop: 1199,
  smallDesktop: 991,
  tablet: 767,
  smallTablet: 650,
  phone: 500,
  smallPhone: 320,
};

export const mediaMaxWidth = Object.keys(maxWidths).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${maxWidths[label] / 16}em) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

// @media min width
const minWidths = {
  largeScreen: 1920,
  mediumScreen: 1537,
  desktop: 1441,
  mediumDesktop: 1200,
  smallDesktop: 992,
  tablet: 768,
  smallTablet: 650,
  phone: 501,
  smallPhone: 321,
};

export const mediaMinWidth = Object.keys(minWidths).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${minWidths[label] / 16}em) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});

// @media max height
const maxHeights = {
  smallDesktop: 760,
  phone: 680,
  smallPhone: 570,
};

export const mediaMaxHeight = Object.keys(maxHeights).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-height: ${maxHeights[label] / 16}em) {
      ${css(...args)}
    }
  `;

  return acc;
}, {});
